import { PageBlock } from '@design-system/page-block';
import {
  ProductComparison,
  ProductDetails,
} from '@design-system/product-comparison';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import React, { FC, useEffect, useState } from 'react';

import { CONTENTSTACK_LEVEL } from '~/gatsby/const';
import { mapGraphQLToProductOptions } from '~/utils/mapGraphQLToProductOptions';

import { ProductComparisonProps } from './models';

const ProductComparisonBlock: FC<ProductComparisonProps> = ({
  pageBlock: { ...pageBlockProps },
  title,
  description,
  featureLabels,
  ctaText,
  dropdownPlaceholder,
  componentId,
}) => {
  const [productOptions, setProductOptions] = useState<ProductDetails[]>([]);

  const data = useStaticQuery(graphql`
    query {
      allContentstackL2ProductPage {
        nodes {
          fields {
            productData {
              ...SalsifyProductFragment
            }
          }
          categories {
            ...CategoryRefFragment
          }
          url
          locale
        }
      }
      allContentstackL3ProductPage {
        nodes {
          fields {
            productData {
              ...SalsifyProductFragment
            }
          }
          categories {
            ...CategoryRefFragment
          }
          url
          locale
        }
      }
    }
  `);

  useEffect(() => {
    const contentStackLevel = process.env.GATSBY_CONTENTSTACK_LEVEL;
    const selectedNodes =
      contentStackLevel === CONTENTSTACK_LEVEL.l3
        ? data.allContentstackL3ProductPage.nodes
        : data.allContentstackL2ProductPage.nodes;

    const allowedLocales = process.env.CONTENTSTACK_LOCALES?.split(',');

    const filteredNodes = selectedNodes.filter((node) =>
      allowedLocales?.includes(node.locale)
    );

    const transformedProductOptions = mapGraphQLToProductOptions({
      nodes: filteredNodes,
    });

    setProductOptions(transformedProductOptions);
  }, [data]);

  return (
    <PageBlock
      {...pageBlockProps}
      id={componentId}
      className="product-comparison-block"
    >
      <ProductComparison
        title={title}
        description={description}
        productOptions={productOptions}
        featureLabels={featureLabels}
        ctaText={ctaText}
        dropdownPlaceholder={dropdownPlaceholder}
        navigate={navigate}
      />
    </PageBlock>
  );
};

export default ProductComparisonBlock;
